import { MapPin, Compass, BookOpen, User } from "lucide-react";

export const navItems = [
  { icon: MapPin, labelKey: "nav.spots", path: "/" },
  { icon: Compass, labelKey: "nav.discover", path: "/discover" },
  { icon: BookOpen, labelKey: "nav.booklets", path: "/booklets" },
  { icon: User, labelKey: "nav.profile", path: "/profile" },
] as const;
